import Head from 'next/head';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.string,
};

const defaultProps = {
  children: '',
};

const DocumentTitle = ({ children }) => (
  <Head>
    <title key="document-title">{`${children}${
      children && ' - '
    }Powered by Foam`}</title>
  </Head>
);

DocumentTitle.propTypes = propTypes;
DocumentTitle.defaultProps = defaultProps;

export default DocumentTitle;
